import _ from 'lodash';

import createEnum from 'scripts/lib/create_enum';
import { PreferencesStatus, RoutingChannel } from 'models/agent_routing_preferences';

// Normalized agent status buckets used by the agents-liveboard status filter.
// Working agents resolve to AVAILABLE/ON_CALL/IN_CONVERSATION/FOCUS; away agents
// resolve to IDLE (no away reason) or AWAY (with a reason).
export const AgentStatusBucket = createEnum('AVAILABLE', 'ON_CALL', 'IN_CONVERSATION', 'FOCUS', 'IDLE', 'AWAY');

// Display order for the filter panel.
export const CHANNEL_FILTER_ORDER = [
  RoutingChannel.MESSAGING,
  RoutingChannel.MAIL,
  RoutingChannel.VOICE,
  RoutingChannel.TASK,
];

export const STATUS_BUCKET_ORDER = [
  AgentStatusBucket.AVAILABLE,
  AgentStatusBucket.IN_CONVERSATION,
  AgentStatusBucket.ON_CALL,
  AgentStatusBucket.FOCUS,
  AgentStatusBucket.IDLE,
  AgentStatusBucket.AWAY,
];

export const EMPTY_FILTERS = Object.freeze({ channels: [], statuses: [] });

export function isFocusOn(agent) {
  return !!(agent.routingPreferences && agent.routingPreferences.status === PreferencesStatus.FOCUS);
}

// Derives the normalized status bucket from a liveboard display agent. Away-card
// entries have no `currentlyOn` and carry an `awayReasonId` (empty for idle);
// working-card entries carry `currentlyOn`/`routingPreferences`.
export function getStatusBucket(agent) {
  if (!agent.currentlyOn) {
    return agent.awayReasonId ? AgentStatusBucket.AWAY : AgentStatusBucket.IDLE;
  }
  if (isFocusOn(agent)) {
    return AgentStatusBucket.FOCUS;
  }
  if (agent.currentlyOn.call) {
    return AgentStatusBucket.ON_CALL;
  }
  if (agent.currentlyOn.activeSessions && agent.currentlyOn.activeSessions.length > 0) {
    return AgentStatusBucket.IN_CONVERSATION;
  }
  return AgentStatusBucket.AVAILABLE;
}

export function activeFilterCount(filters) {
  const { channels = [], statuses = [] } = filters || {};
  return channels.length + statuses.length;
}

export function filterAgents(agents, filters) {
  const { channels = [], statuses = [] } = filters || {};
  if (!activeFilterCount(filters)) {
    return agents;
  }

  return agents.filter(agent => {
    if (channels.length && !_.intersection(agent.availableChannels || [], channels).length) {
      return false;
    }
    if (statuses.length && statuses.indexOf(getStatusBucket(agent)) === -1) {
      return false;
    }
    return true;
  });
}
